// Module
var code = "<div class=\"spot-manual-inputs-contextual\"> <wt-property-grid-table fields=\"vm.properties\" form-controller=\"vm.formController\" item=\"vm.selectedItem.configuration\" modern-design=\"true\"> </wt-property-grid-table> <wt-validation-errors form-controller=\"vm.formController\" fields=\"vm.errors\"> </wt-validation-errors> </div>";
// Exports
module.exports = code;